module.exports = __webpack_public_path__ + "img/gf.e35c2954.svg";